<div class="main-wrapper">
    <div class="row main-row">
        <div class="col-12">
            <div class="inner-wrapper">
                <div class="header">
                    <div class="flexed">
                        <img src="/assets/img/safetly logo.png">
                        <h3>{{'safetly' | translate}}</h3>
                    </div>
                </div>
                <div class="body">
                    <h1>{{'auth.register.title' | translate}}</h1>
                    <p class="suggestion-p">{{'auth.register.suggest' | translate}}</p>
                    <div class="row">
                        <div class="col-12">
                            <form [formGroup]="EmailForm" (ngSubmit)="onContinue()" id='email-form'>
                                <div class="form-group">
                                    <label for="email">{{'auth.register.email' | translate}}</label>
                                    <input class="form-control form-input" type="email" id="email"
                                           formControlName='email'/>
                                </div>
                            </form>
                        </div>
                    </div>
                    <input type="submit"
                           value="{{'buttons.continue' | translate}}"
                           class="btn my-button btn-primary "
                           form="email-form"
                           [disabled]="!this.EmailForm.valid"/>
                    <div class="box">
                        <p class="faded-p mt-0">{{'auth.register.already-registered' | translate}}</p>
                        <p class="login-password-p" routerLink="/login-email">{{'auth.register.login' | translate}}</p>
                    </div>
                </div>
                <div class="footer">
                    <div class="footer-p">
                        <p>{{'auth.footer' | translate}}</p>
                    </div>
                    <div class="btn my-button help-button btn-primary">
                        <img src="/assets/img/question-circle 1.svg">
                        <span>{{'help' | translate}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
